export const initialNotificationState = {
  open: false,
  message: '',
  color: 'primary',
}
